/*
Check screen size to work out which search snippet to target

if we're on mobile, target the sidenav
otherwise if we're on the homepage target the modal on the homepage
otherwise target the dropdown in the nav
*/

/*
if($(window).width() < 640) {
  if(window.location.pathname !== '/') {
    $('.left-off-canvas-menu.show-for-small-only .car-search').addClass('active');
  } else {
    $('.left-off-canvas-toggle').hide();
    $('#carSearchModal .car-search').addClass('active');
  }
} else if(window.location.pathname === '/') {
  $('#carSearchModal .car-search').addClass('active');
} else {
  $('.large-menu-container .car-search').addClass('active');
}
*/

// on first loading the database, get all the data and populate the first dropdown (make of car)
var exactmatsDB;
var currentMakeChoice;
var currentYearChoice;

firebase.database().ref('/').once('value').then(function(snapshot) {

  exactmatsDB = snapshot.val();
  console.log(exactmatsDB);
  $.each(exactmatsDB, function(key, value ) {
    $('.car-search.active .make')
    .append($("<option></option>")
    .attr("value", key)
    .text(key));
  });

  // if a previous search was done, set those values
  var searchParams = window.location.pathname.match(/make-(.+)\+year-(\d+)/);
  if (searchParams[1]) {
    currentMakeChoice = searchParams[1].replace('-', ' ');
    $('.car-search.active .make').val(currentMakeChoice);
    loadYears(currentMakeChoice);
    currentYearChoice = searchParams[2];
    $('.car-search.active .year').val(currentYearChoice);
  }
  
  
});

// watch for what a user chooses in the make of car dropdown and update the year dropdown
$('.car-search.active .make').change(function() {
  currentMakeChoice = this.value;
  loadYears(currentMakeChoice);
});

// watch which year a user chooses
$('.car-search.active .year').change(function() {
  currentYearChoice = this.value;
  window.location = '/collections/all/make-' + currentMakeChoice.replace(/ /g, '-') + '+year-' + currentYearChoice + '+clear';
});

/*
// change to product when model chosen
$('.car-search.active .model').change(function() {
  var currentMakeChoice = $('.car-search.active .make').val();
  var currentYearChoice = $('.car-search.active .year').val();
  window.location = '/products/' + this.value + '?make=' + currentMakeChoice + '&year=' + currentYearChoice;
});

function loadModels(currentYearChoice) {
  // first clear the current model dropdown list
  $('.car-search.active .model')
  .find('option')
  .remove();

  $('.car-search.active .model').append("<option value=''>Model</option>");

  // get car models for that date range
  var model = [];
  var currentMakeChoice = $('.car-search.active .make').val();
  $.each(exactmatsDB[currentMakeChoice], function(key, value) {
    if(value.start <= currentYearChoice && currentYearChoice <= value.end) {
      model.push(key);
    }
  });

  var modelData = [];
  // get all the model data
  model.forEach(function(shopifyProductHandle) {
    modelData.push({
      value: shopifyProductHandle,
      text: exactmatsDB[currentMakeChoice][shopifyProductHandle].model
    });
  });

  // sort the models by name
  modelData.sort(function(a, b) {
    return (a.text > b.text)? 1 : -1;
  });

  // add the sorted models to the dropdown
  modelData.forEach(function(specificModel) {
    $('.car-search.active .model')
    .append($("<option></option>")
    .attr("value", specificModel.value)
    .text(specificModel.text));
  });
}
*/
function loadYears(currentMakeChoice) {
  
  var years = {};
  $.each(exactmatsDB[currentMakeChoice], function(key, value) {
    years[value.start] = 1;
    years[value.end] = 1;
  });

  // first clear the current dropdown list for both year and model
  $('.car-search.active .year, .car-search.active .model')
  .find('option')
  .remove();

  $('.car-search.active .year').append("<option value=''>Year</option>");
  $('.car-search.active .model').append("<option value=''>Model</option>");

  // add all the years to the dropdown for years
  var yearsArray = Object.keys(years).sort().reverse();

  for(var y = yearsArray[0]; y >= yearsArray[yearsArray.length - 1]; y--) {
    $('.car-search.active .year')
    .append($("<option></option>")
    .attr("value", y)
    .text(y));
  }
}
